import React from 'react';
import { WidthLimiter, Wrapper } from 'components/navigation/header/styled';
import { IDeveloperProfile } from 'utils/entities';
import ArrowIcon from 'assets/svg/navigation/chevron-left.svg';
import AccessibilityIcon from 'assets/svg/navigation/accessibility.svg';
import BackLink from 'components/navigation/BackLink';
import { Share } from 'screens/DeveloperPage/components/business-card/Share';
import { ShowAt } from 'consts/breakpoints';
import { noop } from 'lodash';
import Navigation from 'components/navigation';
import * as Styled from './styled';

interface HeaderProps {
  developer: IDeveloperProfile;
  showTitle: boolean;
}

const Header: React.FC<HeaderProps> = ({ developer, showTitle }) => {
  const handleAccessibilityClick = () => {
    const accessibilityButton = document.getElementById('INDmenu-btn');
    if (accessibilityButton) {
      accessibilityButton.click();
    }
  };

  return (
    <Styled.HeaderWrapper>
      <ShowAt at={1}>
        <WidthLimiter>
          <Wrapper className="mobile-header-wrapper" small>
            <Styled.Inner>
              <Styled.BackButtonWrapper data-auto="back-button">
                <BackLink>{<ArrowIcon width={8} height={16} />}</BackLink>
              </Styled.BackButtonWrapper>
              <Styled.Title show={showTitle}>
                <Styled.DeveloperName weight="bold">{developer.name}</Styled.DeveloperName>
              </Styled.Title>
              <Styled.ActionIcons>
                <div>
                  <AccessibilityIcon width={24} height={24} onClick={handleAccessibilityClick} />
                </div>
                <Share iconOnly developer={developer} />
              </Styled.ActionIcons>
            </Styled.Inner>
          </Wrapper>
        </WidthLimiter>
      </ShowAt>
      <ShowAt from={2}>
        <Navigation isMobileMapViewActive={false} setMobileMapViewActive={noop} />
      </ShowAt>
    </Styled.HeaderWrapper>
  );
};

export default React.memo(Header);
